var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuttingGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.25023H8.25V2.75923L6.1875 4.81273L5.127 3.75223L7.9395 0.939727C8.52375 0.354727 9.47625 0.354727 10.0605 0.939727L12.8993 3.71398L11.8507 4.78723L9.75 2.73448V7.25098V7.25023ZM18 9.50023V18.5002H0V9.50023C0 8.25973 1.0095 7.25023 2.25 7.25023H8.25V12.5002H9.75V7.25023H15.75C16.9905 7.25023 18 8.25973 18 9.50023ZM16.5 16.8937V15.2887C16.2735 15.4215 16.0177 15.5002 15.75 15.5002C14.9227 15.5002 14.25 14.8275 14.25 14.0002H12.75C12.75 14.8275 12.0773 15.5002 11.25 15.5002C10.4227 15.5002 9.75 14.8275 9.75 14.0002H8.25C8.25 14.8275 7.57725 15.5002 6.75 15.5002C5.92275 15.5002 5.25 14.8275 5.25 14.0002H3.75C3.75 14.8275 3.07725 15.5002 2.25 15.5002C1.98225 15.5002 1.7265 15.4207 1.5 15.2887V16.8937C1.74375 16.9575 1.9935 17.0002 2.25 17.0002C3.15075 17.0002 3.9495 16.5937 4.5 15.9637C5.0505 16.5937 5.84925 17.0002 6.75 17.0002C7.65075 17.0002 8.4495 16.5937 9 15.9637C9.5505 16.5937 10.3492 17.0002 11.25 17.0002C12.1508 17.0002 12.9495 16.5937 13.5 15.9637C14.0505 16.5937 14.8492 17.0002 15.75 17.0002C16.0065 17.0002 16.2563 16.9575 16.5 16.8937Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuttingGreen);
export default __webpack_public_path__ + "static/media/PuttingGreen.6772233ccd60591932f43f0afb545578.svg";
export { ForwardRef as ReactComponent };